<template>
    <v-dialog
          class="application-permission-cru"
          v-model="showDialog"
          max-width="750px"
          :persistent="true"
    >
        <v-card>
            <v-card-title>{{ dialogTitle }}</v-card-title>
            <v-card-text>
                <v-form v-model="valid" v-on:submit.prevent>
                    <LabelValue
                            v-if="editPermission.id !== null"
                            :label="'ID'"
                            :value="editPermission.id"
                    />
                    <v-text-field
                            :disabled="loading"
                            :value="ssoId"
                            @input="updateSsoId"
                            :rules="ssoIdRules"
                            class="mb-2"
                            label="SSO ID"
                    ></v-text-field>
                    <v-select
                            @input="updateAppId"
                            :value="appId"
                            :rules="appNameRules"
                            class="mb-2"
                            :items="applications"
                            item-text="app"
                            item-value="id"
                            :disabled="loading || applicationsLoading"
                            label="Anwendungsname"
                    ></v-select>
                    <v-textarea
                            :disabled="loading"
                            :value="appData"
                            @input="updateAppData"
                            :rules="appDataRules"
                            class="mb-2"
                            label="Anwendungskonfiguration"
                    ></v-textarea>
                    <LabelValue
                            v-if="editPermission.id !== null"
                            :label="'Erstellt'"
                            :value="editPermission.createdAt"
                    />
                    <LabelValue
                            v-if="editPermission.id !== null"
                            :label="'Aktualisiert'"
                            :value="editPermission.updatedAt"
                    />
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                        color="warning"
                        outlined
                        @click="closeDialog"
                        :disabled="loading || processing"
                >
                    Abbrechen
                </v-btn>
                <v-btn
                        color="success"
                        outlined
                        @click="submit"
                        :loading="processing"
                        :disabled="loading || processing || !valid"
                >
                    Speichern
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

import {
    mapState,
    mapGetters,
    mapMutations,
    mapActions,
} from 'vuex';
import LabelValue from '@/components/LabelValue.vue';

export default {
    name: 'ApplicationPermissionCRU',
    components: {
        LabelValue,
    },
    data() {
        return {
            valid: false,
            appNameRules: [
                v => !!v || 'Es muss eine Anwendung gewählt sein.',
            ],
            appDataRules: [
                (v) => {
                    try {
                        JSON.parse(v);
                    } catch (e) {
                        if (v.trim().length === 0) {
                            return true;
                        }
                        return 'Anwendungskonfiguration ist kein valider JSON.';
                    }
                    return true;
                },
            ],
            ssoIdRules: [
                v => v.length > 0 || 'Die SSO ID muss gesetzt sein.',
                v => /^(\d+|[0-9a-fA-F]{8}(-[0-9a-fA-F]{4}){3}-[0-9a-fA-F]{12})$/.test(v)
                    || 'Die eingegebene SSO ID ist ungültig.',
            ],
        };
    },
    computed: {
        ...mapGetters('applicationPermissions', [
            'dialogTitle',
            'ssoId',
            'appId',
            'appData',
        ]),
        ...mapState('applicationPermissions', [
            'editPermission',
            'showDialog',
            'loading',
            'processing',
            'applications',
            'applicationsLoading',
        ]),
    },
    methods: {
        ...mapActions('applicationPermissions', ['savePermission']),
        ...mapMutations('applicationPermissions', [
            'closeDialog',
            'updateSsoId',
            'updateAppId',
            'updateAppData',
        ]),
        ...mapMutations('snackbar', ['error', 'success']),
        submit() {
            if (this.valid) {
                this.savePermission()
                    .then(() => {
                        this.success('Permission erfolgreich gespeichert.');
                    })
                    .catch(() => {
                        this.error('Es ist ein Fehler aufgetreten.');
                    });
            }
        },
    },
};

</script>
<style scoped lang="scss"></style>
